import _, { uniqueId } from "lodash";
import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FaCircleXmark } from "react-icons/fa6";
import BeatLoader from "react-spinners/BeatLoader";
import {
  useUpdateDocumentsMutation,
  useUpdateRequestMutation,
} from "../../Data/services/profileRequestApi";
import Toast, { ErrorToast, SuccessToast } from "../../Hooks/useToast";
import { Button, SubTitle, Title } from "../CustomComponents";
import LineRow from "../CustomComponents/LineRow";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import ModalContainer from "../ModalContainer";
import UserAvatarWithNameAndTag from "../UserAvatar/UserAvatarWithNameAndTag";
import cssStyles from "./styles/editModal.module.scss";
import LazyLoad from "react-lazy-load";
import ImageWithPlaceholder from "../CustomComponents/ImageWithPlaceholder";

const NurseDocumentModal = ({
  handleUpdateModalClose,
  data,
  handleUpdate,
  refetch,
}) => {
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({});

  const [rowId, setRowId] = useState("");
  const [userSlug, setUserSlug] = useState("");

  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedQuestionType, setSelectedQuestionType] = useState("");

  const statusType = [
    {
      id: 20,
      name: "Approved",
    },
    {
      id: 30,
      name: "Rejected",
    },
  ];

  const statusTypeList = statusType.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (data) {
      console.log(data);
      setRowId(data.id);
      // setUserSlug(data.id);
      // setValue("name", data.name);
    }
  }, [data, mounted]);

  const handleStatusChange = (value) => {
    // console.log(value);
    setSelectedStatus(value);
  };

  const [updateDocuments, { isLoading: updating }] =
    useUpdateDocumentsMutation();

  const handleSendData = async (record) => {
    console.log(record);
    console.log(rowId);

    try {
      const response = await updateDocuments({
        data: record,
        id: rowId,
      }).unwrap();

      console.log(response);

      if (response?.error?.status === 400) {
        console.log(response?.error?.data?.message);
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response?.error?.status === 500) {
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response.code === 200) {
        SuccessToast(response?.message);
        handleUpdateModalClose();
        refetch();
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      }
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleUpdateModalClose}>
        <div
          className={cssStyles.modalContainer}
          style={{ maxWidth: "50%", overflow: "auto" }}
        >
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-semibold m-0 black-text">
              Update Documents Request
            </p>
            <span className="bg-white bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleUpdateModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Row className="w-100">
              <Col sm={12} md={12}>
                <UserAvatarWithNameAndTag
                  userName={`${
                    data?.nurse?.firstname ? data?.nurse?.firstname : ""
                  } ${data?.nurse?.lastname ? data?.nurse?.lastname : ""}`}
                  avatarImage={
                    data?.nurse?.image_url || "/images/user-placeholder.jpeg"
                  }
                />

                <p className="fs-4 fw-semibold black-text mt-4 mb-2">
                  Document Name: {data?.document_name}
                </p>
                <a href={data.document_url} download target="_blank">
                  <LazyLoad
                    key={uniqueId()}
                    height={200}
                    width={"100%"}
                    threshold={0.95}
                    debounce={500}
                    onContentVisible={() => {
                      // console.log("loaded!");
                    }}
                  >
                    <ImageWithPlaceholder
                      src={data.document_url}
                      placeholder={"images/placeholder.webp"}
                      alt="training"
                      className="rounded-3 mx-auto w-100 object-fit-contain bg-black"
                      height={200}
                      width={"100%"}
                    />
                  </LazyLoad>
                </a>

                <Form onSubmit={handleSubmit(handleSendData)} className="mt-4">
                  {errors?.status?.message ? (
                    <p className="m-0 text-danger text-center">
                      {errors?.status?.message}
                    </p>
                  ) : (
                    ""
                  )}
                  <Controller
                    control={control}
                    name="status"
                    rules={{
                      required: "Status Type is required.",
                    }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <SelectFieldComponent
                        firstOption={
                          _.isEmpty(selectedQuestionType)
                            ? "Select Document Status"
                            : selectedQuestionType
                        }
                        optionsList={statusTypeList}
                        value={value}
                        // onSelectChange={handleStatusChange}
                        onSelectChange={onChange}
                      />
                    )}
                  />

                  <Button
                    text={updating ? <BeatLoader size={10} /> : "Save"}
                    classes={`mt-2 mb-2 ${updating ? "bg-white-subtle" : ""}`}
                    type="submit"
                    // onClick={handleSubmit}
                    disabled={updating}
                  />
                </Form>
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default NurseDocumentModal;
